export default __webpack_public_path__ + "img/Montserrat-Light_d66eb8d.eot";